import { defineMessages } from 'react-intl';

export default defineMessages({
  reviewLabel: {
    id: 'review',
    description: 'review',
    defaultMessage: 'review',
  },
  submittedLabel: {
    id: 'submitted',
    description: 'submitted',
    defaultMessage: 'submitted',
  },
});
